import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Skeleton } from '@material-ui/lab'
import { range } from 'lodash'
import { Grid } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  skeletonItem: {
    borderRadius: 16,
    width: '100%'
  }
}))

const CopilotSettingsSkeleton = () => {
  const classes = useStyles()

  return (
    <Grid container spacing={1}>
      {range(6).map(i => (
        <Grid style={{ maxWidth: 200 }} key={`skeleton-${i}`}>
          <Skeleton variant="rect" height={64} className={classes.skeletonItem} />
        </Grid>
      ))}
    </Grid>
  )
}

export default CopilotSettingsSkeleton
